import {
    ADD_UNIT, UPDATE_UNIT, DELETE_UNIT, LOAD_UNITS
} from './actionTypes';

const addUnit = ({propertyId, unitName, rentAmount, occupied, taxRate, otherRecurringBillsItems, notes}) => ({
    type: ADD_UNIT,
    payload: {
        propertyId, 
        unitName,
        rentAmount,
        occupied,
        taxRate,
        otherRecurringBillsItems,
        notes
    },
    errors: null
});

const updateUnit = ({propertyId, unitId, unitName, rentAmount, occupied, taxRate, otherRecurringBillsItems, notes}) => ({
    type: UPDATE_UNIT,
    payload: {
        propertyId, 
        unitId,
        unitName,
        rentAmount,
        occupied,
        taxRate,
        otherRecurringBillsItems,
        notes
    },
    errors: null
});

const deleteUnit = (propertyId, unitId) => ({
    type: DELETE_UNIT,
    payload: {
        propertyId, 
        unitId
    },
    errors: null
});

const fetchUnitsForProperties = (propertyIds) => ({
    type: LOAD_UNITS,
    payload: {
        propertyIds
    },
    errors: null
});



export {
    addUnit, updateUnit, deleteUnit, fetchUnitsForProperties
};